import {
  Box,
  Typography,
  Divider,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import type { MaterialSupplierForm } from "@/api/materialSupplierService";
import type { MaterialType } from "@/api/materialTypeService";

interface MaterialTypeSelectionProps {
  formData: MaterialSupplierForm;
  setFormData: React.Dispatch<React.SetStateAction<MaterialSupplierForm>>;
  matType: MaterialType[];
  materialSupplierId?: number;
  materialSupplierData?: {
    material_type_ids: { id: number }[];
  };
}

const MaterialTypeSelection = ({
  formData,
  setFormData,
  matType,
  materialSupplierId,
  materialSupplierData,
}: MaterialTypeSelectionProps) => {
  return (
    <>
      <Typography variant="h3" mt={2}>
        Material Type
      </Typography>
      <Divider sx={{ my: 1 }} />
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        {matType?.map((mt) => (
          <FormControlLabel
            key={mt.id}
            control={
              <Checkbox
                checked={formData.material_type_ids.includes(mt.id)}
                onChange={() => {
                  setFormData((prevData: MaterialSupplierForm) => {
                    const isSelected =
                      prevData.material_type_ids.includes(mt.id);
                    let updatedMaterialTypes: Array<number>;
                    if (isSelected) {
                      updatedMaterialTypes =
                        prevData.material_type_ids.filter(
                          (id: number) => id !== mt.id
                        );
                    } else {
                      updatedMaterialTypes = [
                        ...prevData.material_type_ids,
                        mt.id,
                      ];
                    }
                    return {
                      ...prevData,
                      material_type_ids: updatedMaterialTypes,
                    };
                  });
                }}
                disabled={
                  !!materialSupplierId &&
                  materialSupplierData?.material_type_ids.some(
                    (mtSup: { id: number }) => mtSup.id === mt.id
                  )
                }
              />
            }
            label={mt.material_type_name}
            sx={{
              width: "calc(20% - 8px)",
              margin: 0,
              "& .MuiFormControlLabel-label": {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }}
          />
        ))}
      </Box>
    </>
  );
};

export default MaterialTypeSelection;